import { BadgeProps } from 'lib/components/badge/Badge.vue.d';

export type SalesStatus =
  | 'Menyetujui'
  | 'Menolak'
  | 'Menunggu Approval'
  | 'Aktif'
  | 'Disetujui'
  | 'Selesai'
  | 'Ditolak'
  | 'Dibatalkan';

export default function getStatusSeverity(
  status: SalesStatus,
): BadgeProps['severity'] {
  switch (status) {
    case 'Selesai':
    case 'Menyetujui':
      return 'success';

    case 'Menunggu Approval':
      return 'warning';

    case 'Dibatalkan':
    case 'Ditolak':
    case 'Menolak':
      return 'danger';

    case 'Aktif':
    default:
      return 'primary';
  }
}
